var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIgGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.087,
    height: 22.076,
    viewBox: "0 0 22.087 22.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5.682,
    y1: -1.74,
    x2: 1.966,
    y2: 1.031,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b998e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#27a486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#46b07c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#5db975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#6abe71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc070"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M1294.889,79H1285.2a6.2,6.2,0,0,0-6.2,6.2v9.682a6.2,6.2,0,0,0,6.2,6.2h9.693a6.2,6.2,0,0,0,6.2-6.2V85.2A6.2,6.2,0,0,0,1294.889,79Zm4.171,15.879a4.175,4.175,0,0,1-4.171,4.171H1285.2a4.176,4.176,0,0,1-4.171-4.171V85.2a4.175,4.175,0,0,1,4.171-4.171h9.693a4.175,4.175,0,0,1,4.171,4.171ZM1290.043,84.4a5.629,5.629,0,1,0,5.629,5.629A5.635,5.635,0,0,0,1290.043,84.4Zm0,9.242a3.6,3.6,0,1,1,3.6-3.6A3.61,3.61,0,0,1,1290.043,93.646Zm7.216-9.574a1.351,1.351,0,1,1-1.351-1.351A1.345,1.345,0,0,1,1297.259,84.071Z",
    transform: "translate(-1279 -79)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgGreen);
export default __webpack_public_path__ + "static/media/igGreen.039b80c9f806b619933f1fd912197d3a.svg";
export { ForwardRef as ReactComponent };